import { CommonModule, TitleCasePipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatPaginatorModule } from '@angular/material/paginator'
import { YouTubePlayerModule } from '@angular/youtube-player'
import { GbDashboardSharedFeatureModule } from '@galabid/gb-dashboard/shared/feature'
import { GbDashboardSharedUiModule } from '@galabid/gb-dashboard/shared/ui'
import { GbDashboardSharedUtilsModule } from '@galabid/gb-dashboard/shared/utils'
import { GbDashboardStaffDataAccessModule } from '@galabid/gb-dashboard/staff/data-access'
import { GbDashboardStaffDataAccessSiteAnnouncementsModule } from '@galabid/gb-dashboard/staff/data-access-site-announcements'
import { LetDirective } from '@ngrx/component'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardStaffDataAccessTutorialVideosModule } from 'gb-dashboard/staff/data-access-tutorial-videos'
import { GbDashboardCoreFeatureModule } from 'libs/gb-dashboard/core/feature/src/lib/gb-dashboard-core-feature.module'
import { GbDashboardStaffDataAccessUserAccountsModule } from 'libs/gb-dashboard/staff/data-access-user-accounts/src/lib/gb-dashboard-staff-data-access-user-accounts.module'
import { GbDisplayNamePipe } from 'libs/shared/utils/pipes/src/lib/gb-display-name-pipe/gb-display-name.pipe'
import { GbAddEditTutorialVideoComponent } from './gb-add-edit-tutorial-video/gb-add-edit-tutorial-video.component'
import { GbArchiveUserDialogComponent } from './gb-archive-user-dialog/gb-archive-user-dialog.component'
import { GbAwsToolsComponent } from './gb-aws-tools/gb-aws-tools.component'
import { GbClientAccountsPreviewComponent } from './gb-client-accounts-preview/gb-client-accounts-preview.component'
import { GbCreateSiteAnnouncementDialogComponent } from './gb-create-site-announcement-dialog/gb-create-site-announcement-dialog.component'
import { GbDashboardStaffFeatureShellRoutingModule } from './gb-dashboard-staff-feature-shell-routing.module'
import { GbNeedSomeHelpComponent } from './gb-need-some-help/gb-need-some-help.component'
import { GbSetupTutorialVideosComponent } from './gb-setup-tutorial-videos/gb-setup-tutorial-videos.component'
import { GbStaffAnnouncementsComponent } from './gb-staff-announcements/gb-staff-announcements.component'
import { GbStaffReportsDownloadDialogComponent } from './gb-staff-reports-download-dialog/gb-staff-reports-download-dialog.component'
import { GbStaffReportsComponent } from './gb-staff-reports/gb-staff-reports.component'
import { GbStaffComponent } from './gb-staff/gb-staff.component'
import { GbTutorialPopupVideoComponent } from './gb-tutorial-popup-video/gb-tutorial-popup-video.component'
import { GbUserAccountsCampaignPreviewComponent } from './gb-user-accounts-campaign-preview/gb-user-accounts-campaign-preview.component'
import { GbUserAccountsComponent } from './gb-user-accounts/gb-user-accounts.component'

@NgModule({
  imports: [
    LetDirective,
    CommonModule,
    GbDashboardStaffFeatureShellRoutingModule,
    GbDashboardCoreFeatureModule,
    GbDashboardSharedFeatureModule,
    TranslateModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    MatDialogModule,
    GbDashboardSharedUiModule,
    GbDashboardStaffDataAccessModule,
    GbDashboardStaffDataAccessSiteAnnouncementsModule,
    ReactiveFormsModule,
    GbDashboardSharedUtilsModule,
    YouTubePlayerModule,
    MatPaginatorModule,
    GbDashboardStaffDataAccessTutorialVideosModule,
    MatIconModule,
    GbDashboardStaffDataAccessUserAccountsModule,
    GbDisplayNamePipe,
  ],
  providers: [TitleCasePipe],
  declarations: [
    GbStaffComponent,
    GbStaffAnnouncementsComponent,
    GbStaffReportsComponent,
    GbStaffReportsDownloadDialogComponent,
    GbCreateSiteAnnouncementDialogComponent,
    GbTutorialPopupVideoComponent,
    GbSetupTutorialVideosComponent,
    GbAddEditTutorialVideoComponent,
    GbNeedSomeHelpComponent,
    GbAwsToolsComponent,
    GbUserAccountsComponent,
    GbUserAccountsCampaignPreviewComponent,
    GbArchiveUserDialogComponent,
    GbClientAccountsPreviewComponent,
  ],
  exports: [GbNeedSomeHelpComponent],
})
export class GbDashboardStaffFeatureShellModule {}
